import React, { useState } from "react";
import { Modal, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { ErrorMessage } from "../../Notifications/Notifications";

export function ConfirmationModal({ state: { show, isLoading, onClose, onConfirmation, configuration: { title, textContent, buttonText, buttonType, useComment = false, requireComment = false } } }) {
    const { t } = useTranslation();
    const [comment, setComment] = useState(null)

    const onSubmit = async (e) => {
        if (isLoading == true) return
        if (requireComment && (comment == null || comment.trim() == "")) {
            ErrorMessage(t('commons.commentRequired'))
            return;
        }
        await onConfirmation({ comment: comment })
    }

    const onHandleCommentChange = (e) => {
        setComment(e.target.value)
    }

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span>{textContent}</span>
                {(useComment || requireComment) && <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginTop: '1rem' }}>
                    <textarea className="form-control" rows="3" onChange={onHandleCommentChange}
                        placeholder={requireComment ? `${t('commons.comment')} (*)` : t('commons.comment')}></textarea>
                </div>}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onClose}>{t('buttons.close')}</Button>
                <button type="button" className={`btn btn-${buttonType} btn-right`} disabled={isLoading} onClick={onSubmit}>{buttonText}</button>
            </Modal.Footer>
        </Modal >
    )
}  